<template>
  <div class="DarkWhite">
    <v-data-table
      :headers="headers"
      :items="rspiList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            style="max-width: 300px"
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search RSPI number"
            color="green darken-2"
            class="mr-2 mt-2"
            dense
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="FundCode"
            item-text="Description"
            item-value="FundCode"
            :items="funds"
            hide-details
            class="mr-2 mt-2"
            style="max-width:200px;"
            color="header"
            label="Filter by Funds"
          >
          </v-autocomplete>
          <v-btn
            color="header"
            dark
            v-if="$store.state.user.roleID == 6"
            @click="createRSPI()"
          >
          <v-icon class="mr-1">mdi-folder-plus</v-icon>
            CREATE RSPI
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.FundCode`]="{ item }">
        {{ item.FundCode }}
      </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
        {{ formatDate(item.DateCreated) }}
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        <v-chip color="amber darken-2" dark small v-if="item.IsCancelled == 1">Cancelled</v-chip>
        <span v-else>
        <v-chip color="green darken-2" dark small v-if="item.VerifiedStatusID == 7">Verified</v-chip>
        <v-chip color="red darken-2" dark small v-else-if="item.VerifiedStatusID == 6">Pending</v-chip>
        <v-chip color="grey darken-1" dark small v-else-if="item.VerifiedStatusID == null">For Verification</v-chip>
        </span>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn
            color="blue darken-2"
            class="mr-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="viewRSPI(item)"
          >
            View
          </v-btn>
          <v-btn
            color="red darken-2"
            dark
            outlined
            elevation="2"
            x-small
            @click="printRSMI(item)"
          >
            Print
          </v-btn>
        </span>
      </template>
    </v-data-table>
    <CreateRSPIModal :rspiData="rspiData" />
    <ViewRSPIModal :rspiData="viewData" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    CreateRSPIModal: () => import("./CreateRSPI.vue"),
    ViewRSPIModal: () => import("./ViewRSPI.vue"),
  },
  props: {
    fiscalYear: null
  },
  data: () => ({
    searchText: "",
    searchTimeout: null,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    rspiList: [],
    rspiData: [],
    dispenseData: [],
    headers: [
      {
          text: 'RSPI CODE',
          align: 'start',
          sortable: false,
          value: 'RSPICODE',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Fund Code',
          align: 'center',
          sortable: false,
          value: 'FundYear',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'Description',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: '# of ICS',
          align: 'center',
          sortable: false,
          value: 'ICSCount',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Created',
          align: 'start',
          sortable: false,
          value: 'DateCreated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        // {
        //   text: 'Printed?',
        //   align: 'center',
        //   sortable: false,
        //   value: 'IsPrinted',
        //   class: "green darken-2 white--text text-caption font-weight-bold"
        // },
        {
        text: "Status",
        value: "Status",
        align: "center",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold"
      },
        { text: 'Actions', value: 'Actions', align: 'center', width: '140', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      itemToPrint: [],
      userList: [],
      userID: 0,
      funds: [],
      FundCode: 0,
      viewData: [],
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    fiscalYear: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    userID: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    FundCode: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeViewRSPI", () => {
      this.initialize();
    });
    this.eventHub.$on("closeCreateRSPI", () => {
      this.initialize();
    });
    this.getUsers();
    this.getFundCodes();
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewRSPI");
    this.eventHub.$off("closeCreateRSPI");
  },
  methods: {
    createRSPI() {
      this.rspiData = [];
    },
    viewRSPI(item) {
      this.viewData = item;
    },
    printRSMI(item) {
      this.link = this.apiUrl + "/rspi/report/" + item.RSPIID;
      window.open(this.link);
    },
    initialize() {
      this.loading = true;
      if(this.fiscalYear != null){
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("tab", this.tab);
      data.append("searchText", this.searchText);
      data.append("FiscalYearID", this.fiscalYear);
      data.append("UserID", this.userID);
      data.append("FundCode", this.FundCode);
      this.axiosCall("/getRSPIList", "POST", data).then((res) => {
        this.loading = false;
        this.rspiList = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
      }
    },
    getUsers() {
      this.axiosCall("/getAllPersonsAccountable", "GET").then((res) => {
        this.userList = [{UserID: 0, name: "All"},...res.data.data];
      });
    },
    selectPrinted(item) {
      let data = new FormData();
      data.append("id", item.RSPIID);
      data.append("table", 'rspi');
      data.append("column", 'RSPIID');
      data.append("IsPrinted", item.IsPrinted ? 1 : 0);
      this.axiosCall("/setPrinted", "POST", data).then((res) => {
        if(res.data.status){
          let msg = item.IsPrinted ? 'printed.' : 'not printed.';
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = item.RSPICODE + " was successfully set to " + msg;
          this.fadeAwayMessage.header = "System Message";
        }
        else{
          item.IsPrinted = !item.IsPrinted;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
    getFundCodes() {
      this.axiosCall(
              '/get/getUniqueFundCodes',
              'GET'
          )
          .then((res) => {
              this.funds = this.prepend({FundCode: 0, Description: 'All'},res.data.data);
          })
		},
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>